// extracted by mini-css-extract-plugin
export var container = "_sy-0";
export var table = "_sy-2";
export var tableWrapper = "_sy-1";